<template>
    <span @touchstart="handleTouchStart" @mouseenter="handleMouseEnter" @click="handleClick">
        <slot />
    </span>
</template>

<script>
    let lastHoveredToggle = null;

    export default {
        props: {
            for: {type: String, required: true},
            // Allow disabling hoverable tooltips for easier debugging.
            [location.search.includes('no-hoverable-tooltips') ? 'ignoreThis' : 'hoverable']: Boolean,
        },

        data() {
            return {
                hasBeenTouched: false
            };
        },

        methods: {
            handleTouchStart() {
                this.hasBeenTouched = true;
            },

            handleMouseEnter() {
                // If a toggle's been touched, treat is as non-hoverable.
                if (!this.hoverable || this.hasBeenTouched) {
                    this.hasBeenTouched = false; // Reset it for the next mouse event.
                    return;
                }

                lastHoveredToggle = this;
                this.$root.showTooltip(this.for, this.$el.children[0], false);
                addEventListener('mousemove', this.handleHoverableMouseMove);
            },

            handleHoverableMouseMove(event) {
                clearTimeout(this.hoverTimeout);

                // We'll hide immediately if another toggle has been hovered over.
                const delay = lastHoveredToggle === this ? 100 : 0;

                this.hoverTimeout = setTimeout(() => {
                    const toggleEl = this.$el;
                    const tooltipEl = document.getElementById(this.for);
                    const toggleDescendants = toggleEl ? toggleEl.querySelectorAll('*') : [];
                    const tooltipDescendants = tooltipEl ? tooltipEl.querySelectorAll('*') : [];
                    const hoveredElement = document.elementFromPoint(event.pageX - pageXOffset, event.pageY - pageYOffset);

                    const stayOpen = [
                        toggleEl,
                        tooltipEl,
                        ...toggleDescendants,
                        ...tooltipDescendants
                    ].includes(hoveredElement);

                    if (stayOpen) {
                        return;
                    }

                    this.$root.hideTooltip(this.for);
                    removeEventListener('mousemove', this.handleHoverableMouseMove);

                    if (lastHoveredToggle === this) {
                        lastHoveredToggle = null;
                    }
                }, delay);
            },

            handleClick(event) {
                if (this.$root.openTooltips[this.for]) {
                    this.$root.hideTooltip(this.for);
                } else {
                    event.preventDefault();
                    this.$root.showTooltip(this.for, this.$el.children[0], true);
                }
            }
        }
    };
</script>
